import { render, staticRenderFns } from "./BookmarkDialog.vue?vue&type=template&id=281030a8&scoped=true&"
import script from "./BookmarkDialog.vue?vue&type=script&lang=js&"
export * from "./BookmarkDialog.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkDialog.vue?vue&type=style&index=0&id=281030a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281030a8",
  null
  
)

export default component.exports